import React, { useState, useEffect } from 'react';
import MobileFilterCollapse, { searchSummary } from '../common/form/MobileFilterCollapse';
import { Box, TextField, Button, MenuItem } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import SearchCodeSelectbox from '../common/form/selectbox/SearchCodeSelectbox';
import MobileSearchAdornment from '../common/search/MobileSearchAdornment';
import {
  firstDayofYear,
  getFirstDayOfYear,
  getLastDayOfYear,
  lastDayofYear,
  subYearStrDt,
} from '../../utils/calcDatetime';

export const ChanceFailListBox = ({ formik }) => {
  const [searchStrtDt, setSearchStrtDt] = useState(null);
  const [searchEndDt, setSearchEndDt] = useState(null);

  useEffect(() => {
    if (formik.values.searchStrtDt) {
      setSearchStrtDt(dayjs(formik.values.searchStrtDt));
    }
    if (formik.values.searchEndDt) {
      setSearchEndDt(dayjs(formik.values.searchEndDt));
    }
  }, [formik.values.searchStrtDt, formik.values.searchEndDt]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  const handleChangeThisYear = () => {
    formik.setFieldValue('searchStrtDt', dayjs(firstDayofYear));
    formik.setFieldValue('searchEndDt', dayjs(lastDayofYear));
  };

  const handleChangeLastYear = () => {
    const paramDate = subYearStrDt(1);
    const strDt = getFirstDayOfYear(paramDate);
    const endDt = getLastDayOfYear(paramDate);

    formik.setFieldValue('searchStrtDt', dayjs(strDt));
    formik.setFieldValue('searchEndDt', dayjs(endDt));
  };

  return (
    <MobileFilterCollapse summary={searchSummary(formik.values)}>
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': { m: 1, width: '20ch' },
            }}
          >
            <SearchCodeSelectbox
              formik={formik}
              variant="standard"
              name="searchPrjImpt"
              label="프로젝트 중요도"
              required={false}
              fullWidth
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'FORCAST',
                slcCd: 'PRJ_IMPT',
              }}
            />
            <TextField
              variant="standard"
              required={false}
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
              error={
                formik.touched.searchKeyword &&
                Boolean(formik.errors.searchKeyword)
              }
              helperText={
                formik.touched.searchKeyword && formik.errors.searchKeyword
              }
            >
              <MenuItem value="cstNm">사업명</MenuItem>
              <MenuItem value="prjNo">프로젝트 번호</MenuItem>
              <MenuItem value="vendorCmpNm">매출처명</MenuItem>
              <MenuItem value="crtDptNm">부서</MenuItem>
              <MenuItem value="crtNm">영업담당자</MenuItem>
              <MenuItem value="cstStatus">상태</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              required={false}
              id="searchWords"
              name="searchWords"
              label="검색어"
              value={formik.values.searchWords}
              onChange={formik.handleChange}
              error={
                formik.touched.searchWords && Boolean(formik.errors.searchWords)
              }
              helperText={
                formik.touched.searchWords && formik.errors.searchWords
              }
              InputProps={{
                endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
              }}
            />
          </Box>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="매출 시작일"
                format="YYYY-MM-DD"
                id="searchStrtDt"
                name="searchStrtDt"
                value={searchStrtDt}
                onChange={(newValue) => {
                  setSearchStrtDt(newValue);
                  onChangeDate(newValue, 'searchStrtDt');
                }}
                slotProps={{
                  textField: {
                    variant: 'standard',
                    fullWidth: true,
                    error: formik.touched.searchStrtDt && Boolean(formik.errors.searchStrtDt),
                    helperText: formik.touched.searchStrtDt && formik.errors.searchStrtDt,
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ mx: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="매출 종료일"
                format="YYYY-MM-DD"
                id="searchEndDt"
                name="searchEndDt"
                value={searchEndDt}
                onChange={(newValue) => {
                  setSearchEndDt(newValue);
                  onChangeDate(newValue, 'searchEndDt');
                }}
                slotProps={{
                  textField: {
                    variant: 'standard',
                    fullWidth: true,
                    error: formik.touched.searchEndDt && Boolean(formik.errors.searchEndDt),
                    helperText: formik.touched.searchEndDt && formik.errors.searchEndDt,
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ mr: 2 }}>
            <Button
              variant="outlined"
              color="info"
              onClick={handleChangeThisYear}
            >
              금년
            </Button>
            <Button
              variant="outlined"
              color="info"
              onClick={handleChangeLastYear}
              sx={{ mx: 1 }}
            >
              작년
            </Button>
          </Box>

          <Box>
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              검색
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
    </MobileFilterCollapse>
  );
};
